import { render, staticRenderFns } from "./APhotoGalleryActionBar.vue?vue&type=template&id=77cb6d32&scoped=true"
import script from "./APhotoGalleryActionBar.vue?vue&type=script&lang=js"
export * from "./APhotoGalleryActionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb6d32",
  null
  
)

export default component.exports